/* global window */
import { saveAs } from 'file-saver'
const mime = require('mime/lite')

/* @ngInject */
function utils ($rootScope, $timeout, $window, $state, $http, $location, $sce, $translate, $filter, $cookies, ConnectorWebService, ToastService, ModalService, $q) {
  var oUtils = {}

  oUtils.fnReplaceStringParams = function (sString, aParams) {
    jQuery.each(aParams, function (index, param) {
      var sPosition = '{' + index + '}'
      sString = sString.replace(sPosition, param)
    })

    return sString
  }

  oUtils.fnAddCategoryQueryToUrl = function (sUrl, iCategoryId) {
    var mQueryParams = {
      categoryId: iCategoryId
    }

    return oUtils.fnAddQueryToUrl(sUrl, mQueryParams)
  }

  oUtils.fnAddTopSkipQueriesToUrl = function (sUrl, iTop, iSkip) {
    var mQueryParams = {
      $top: iTop,
      $skip: iSkip
    }

    return oUtils.fnAddQueryToUrl(sUrl, mQueryParams)
  }

  // tem que ser alterado os param para a request
  oUtils.fnAddStartEndQueriesToUrl = function (url, options) {
    if (!options) {
      return url
    }

    let start = options.start
    if (start && typeof start !== 'string') {
      start = start.utc().startOf('day').format()
    }

    let end = options.end
    if (end && typeof end !== 'string') {
      end = end.utc().endOf('day').format()
    }

    const queryParams = {
      $periodStart: start,
      $periodEnd: end
    }
    return oUtils.fnAddQueryToUrl(url, queryParams)
  }

  oUtils.fnAddQueryToUrl = function (url, queryParams) {
    let join = '?'
    const paramNames = Object.keys(queryParams)

    if (paramNames.length === 0) {
      return url
    }

    const alreadyHaveQueryParams = url.indexOf('?') > -1
    if (alreadyHaveQueryParams) {
      join = '&'
    }

    const params = paramNames.map((param) => {
      const value = queryParams[param]

      const isNull = value === null
      const isUndefined = value === undefined
      const isEmptyString = typeof value === 'string' && value.trim() === ''
      const isEmptyArray = Array.isArray(value) && !value.length
      const isEmptyObject = value && typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0 && value.constructor === Object

      if (isNull || isUndefined || isEmptyString || isEmptyArray || isEmptyObject) {
        return ''
      }

      return param + '=' + value
    })

    const queryString = params.filter(Boolean).join('&')
    if (queryString === '') {
      return url
    }

    return url + join + queryString
  }

  oUtils.errorCallbackRedirectToLogin = function (oResponse) {
    if (Number.parseInt(oResponse.status) === 401) {
      $state.go('login')
    }
  }

  oUtils.getSystemLang = function () {
    var lang = window.navigator.userLanguage || window.navigator.language
    // if it is not portuguese, then return english
    return lang === 'pt-BR' ? 'pt-BR' : 'en-US'
  }

  oUtils.isPhone = function () {
    return !oUtils.isScreenHigherThan(768) && !oUtils.isScreenLargerThan(500)
  }

  oUtils.isScreenLargerThan = function (width) {
    return $(window).width() >= width
  }

  oUtils.isScreenHigherThan = function (height) {
    return $(window).height() >= height
  }

  oUtils.isSafari = function () {
    // chrome has both safari and chrome in the userAgent attribute
    return navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1
  }

  oUtils.enableDimmerHover = function (cssSelector) {
    jQuery(cssSelector).dimmer({
      on: 'hover'
    })
  }

  oUtils.roundNumber = function (num, scale) {
    if (!('' + num).includes('e')) {
      return +(Math.round(num + 'e+' + scale) + 'e-' + scale)
    } else {
      var arr = ('' + num).split('e')

      var sig = ''
      if (+arr[1] + scale > 0) {
        sig = '+'
      }
      return +(Math.round(+arr[0] + 'e' + sig + (+arr[1] + scale)) + 'e-' + scale)
    }
  }

  oUtils.beautifyContentTypes = function (sContentType) {
    return mime.getExtension(sContentType) || ''
  }

  oUtils.getReadableFileSizeString = function (fileSizeInBytes) {
    var i = -1
    var byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB']
    do {
      fileSizeInBytes = fileSizeInBytes / 1024
      i++
    } while (fileSizeInBytes > 1024)

    return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i]
  }

  oUtils.isChromeBrowser = function () {
    return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)
  }

  oUtils.parseTimeFromInteger = function (value) {
    var newValue = parseInt(value / 60, 10) + ':' + parseInt(value % 60)
    if (newValue.search(/:/) === 1) {
      newValue = '0' + newValue
    }
    if (newValue.length === 4) {
      newValue = newValue + '0'
    }
    return newValue
  }

  oUtils.cloneObject = function (obj) {
    var newObj = {}
    for (var key in obj) {
      if (typeof obj[key] === 'object') {
        newObj[key] = oUtils.cloneObject(obj[key])
      } else {
        newObj[key] = obj[key]
      }
    }
    return newObj
  }

  oUtils.afterSendToApprovalDialog = function (hoursNow, dayNow, MessageService, $rootScope) {
    const isBusinessHoursEnabled = $rootScope.oUserCompanyConfigurations.ENABLE_BUSINESS_HOURS
    const isApprovalTime = hoursNow >= $rootScope.oUserCompanyConfigurations.BUSINESS_START_HOUR && hoursNow <= $rootScope.oUserCompanyConfigurations.BUSINESS_END_HOUR

    if ((isBusinessHoursEnabled && !isApprovalTime) ||
      (isBusinessHoursEnabled && (
        (dayNow === 0 && !$rootScope.oUserCompanyConfigurations.ENABLE_APPROVAL_SUNDAY) ||
        (dayNow === 1 && !$rootScope.oUserCompanyConfigurations.ENABLE_APPROVAL_MONDAY) ||
        (dayNow === 2 && !$rootScope.oUserCompanyConfigurations.ENABLE_APPROVAL_TUESDAY) ||
        (dayNow === 3 && !$rootScope.oUserCompanyConfigurations.ENABLE_APPROVAL_WEDNESDAY) ||
        (dayNow === 4 && !$rootScope.oUserCompanyConfigurations.ENABLE_APPROVAL_THURSDAY) ||
        (dayNow === 5 && !$rootScope.oUserCompanyConfigurations.ENABLE_APPROVAL_FRIDAY) ||
        (dayNow === 6 && !$rootScope.oUserCompanyConfigurations.ENABLE_APPROVAL_SATURDAY)
      ))
    ) {
      var sText = $translate.instant('approvalOnlyOnDays'); var approvalDays = []
      if ($rootScope.oUserCompanyConfigurations.ENABLE_APPROVAL_SUNDAY) approvalDays.push('sunday')
      if ($rootScope.oUserCompanyConfigurations.ENABLE_APPROVAL_MONDAY) approvalDays.push('monday')
      if ($rootScope.oUserCompanyConfigurations.ENABLE_APPROVAL_TUESDAY) approvalDays.push('tuesday')
      if ($rootScope.oUserCompanyConfigurations.ENABLE_APPROVAL_WEDNESDAY) approvalDays.push('wednesday')
      if ($rootScope.oUserCompanyConfigurations.ENABLE_APPROVAL_THURSDAY) approvalDays.push('thursday')
      if ($rootScope.oUserCompanyConfigurations.ENABLE_APPROVAL_FRIDAY) approvalDays.push('friday')
      if ($rootScope.oUserCompanyConfigurations.ENABLE_APPROVAL_SATURDAY) approvalDays.push('saturday')
      sText += ' '
      approvalDays.forEach(function (day, index) {
        sText += $translate.instant(day)
        sText += (index < approvalDays.length - 1) ? ', ' : ' '
      })
      sText += $translate.instant('hoursFrom') + ' ' + oUtils.parseTimeFromInteger($rootScope.oUserCompanyConfigurations.BUSINESS_START_HOUR) + ' ' + $translate.instant('hoursTo') + ' ' + oUtils.parseTimeFromInteger($rootScope.oUserCompanyConfigurations.BUSINESS_END_HOUR)
      return MessageService.warning({
        title: $translate.instant('approvalHoursWarningTitle'),
        text: sText,
        confirmButton: $translate.instant('ok')
      })
    }
    ToastService.defaultSuccessToast()
  }

  oUtils._downloadFileOnChrome = function (oOptions) {
    var a = document.createElement('a')
    a.href = oOptions.sUrl
    a.target = '_blank'
    a.download = oOptions.sFileName + '.' + oOptions.sExtension
    document.body.appendChild(a)

    $timeout(() => {
      a.click()
      a.remove()
    }, 0, false)

    ToastService.showSuccessToast($translate.instant('downloadWillStartSoon'))
  }

  oUtils._downloadFileOnOtherBrowsers = function (oOptions) {
    function progress (evt) {
      if (evt.lengthComputable) {
        var percent = parseInt(100 * evt.loaded / evt.total)
        jQuery('.progress.download-dialog-progress').progress({
          percent: percent
        })

        if (percent >= 100) {
          ModalService.close()
        }
      }
    }

    ConnectorWebService.createCustomXHR(oOptions.sUrl, 'GET', null, { responseType: 'blob' }, {
      load: () => {
        return function () {
          const blob = this.response

          if (!oOptions.sFileExtension) {
            oOptions.sFileExtension = oUtils.beautifyContentTypes(this.getResponseHeader('Content-Type'))
          }

          saveAs(blob, oOptions.sFileName + '.' + oOptions.sFileExtension)
        }
      },
      progress: progress
    })

    ModalService.showModal({
      templateId: 'downloadProgress.html',
      templateUrl: '/arts/dialogs/download-progress/download-progress-dialog.html?$$REVISION$$',
      destroyable: true
    })
  }

  /* Download file
  *  params: {oOptions}
  *          {oOptions.sUrl}
  *          {oOptions.sFileName} file name without extension
  *          {oOptions.sExtension} file extension
  *          {oOptions.sContentType} file content type
  */
  oUtils.downloadAsset = function (oOptions) {
    oOptions.sFileName = oOptions.sFileName || 'Deskfy'
    oOptions.sExtension = oOptions.sExtension || oUtils.beautifyContentTypes(oOptions.sContentType)

    if (oUtils.isChromeBrowser()) {
      oUtils._downloadFileOnChrome(oOptions)
    } else {
      oUtils._downloadFileOnOtherBrowsers(oOptions)
    }
  }

  oUtils.optimizeAsset = function (asset) {
    let size = asset.size
    let contentType = asset.contentType

    if (!size) {
      const file = asset.files?.find?.(file => file.quality === 'ORIGINAL')

      if (file?.size) {
        size = file.size
      }

      if (file?.contentType) {
        contentType = file.contentType
      }
    }

    const mbSize = size * 0.000001
    const extension = contentType.split('/')[1]

    return mbSize >= 4 || extension === 'tiff'
  }

  oUtils.getFileSizeInMbs = function (size) {
    return size * 0.000001
  }

  /* Toggles a item in determined array
   * Add the item if it is not there yet or delete it if it is already on the array
  */
  oUtils.toggleItemOnArray = function (array, item, comparable) {
    const defaultComparable = (a, b) => a === b
    const itemComparable = comparable || defaultComparable
    var index = $.map(array, function (value, i) {
      if (itemComparable(value, item)) {
        return i
      }
    })[0]

    if (index === undefined) {
      array.push(item)
    } else {
      array.splice(index, 1)
    }
  }

  /**
   * Convert image in url to file type
   */
  oUtils.urlToFile = function (url, filename, mimeType) {
    return $http.get(url, { responseType: 'arraybuffer' })
      .then(function (buf) {
        return new File([buf.data], filename, { type: mimeType })
      })
  }

  /* Get Minimal Date
  *
  *   Similar to moment().add(), this adds just working days to a moment() object and returns it
  */
  oUtils.getMinDate = (days, initialDate = null) => {
    function _getDaysToBeAdded () {
      return Math.floor(days / 5) * 7
    }

    function _getMomentObj () {
      if (initialDate) {
        return moment(initialDate).add(_getDaysToBeAdded(), 'd')
      }
      return moment().add(_getDaysToBeAdded(), 'd')
    }

    function _getWorkingDaysToBeAdded (moment, remaining) {
      if (remaining === 0) {
        return moment
      }

      moment.add(1, 'd')
      if (moment.day() !== 0 && moment.day() !== 6) { // if it's a working day
        return _getWorkingDaysToBeAdded(moment, remaining - 1)
      }
      return _getWorkingDaysToBeAdded(moment, remaining)
    }

    return _getWorkingDaysToBeAdded(_getMomentObj(), days % 5)
  }

  oUtils.isInCordovaWebView = function () {
    return window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.cordova_iab && window.webkit.messageHandlers.cordova_iab.postMessage
  }

  oUtils.isInReactNativeWebView = function () {
    return window.ReactNativeWebView && window.ReactNativeWebView.postMessage
  }

  oUtils.downloadFile = function (url, options) {
    return $q(function (resolve) {
      const isInCordovaWebView = oUtils.isInCordovaWebView()
      const isInReactNativeWebView = oUtils.isInReactNativeWebView()
      if (isInCordovaWebView || isInReactNativeWebView) {
        const jwt = $cookies.get('jwt')
        const msg = { url: oUtils.fnAddQueryToUrl(url, { jwt: jwt }), locale: $rootScope.oUser.locale, type: 'DOWNLOAD_ART', jwt }

        if (options && options.artId) {
          msg.artId = options.artId
        }

        if (isInCordovaWebView) {
          window.webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify(msg))
        } else if (isInReactNativeWebView) {
          window.ReactNativeWebView.postMessage(JSON.stringify(msg))
        }

        resolve()
        return
      }
      const iframe = document.createElement('iframe')
      const link = document.createElement('a')
      iframe.style.display = 'none'
      link.href = url
      link.download = ''

      link.addEventListener('click', () => {
        link.remove()
        iframe.remove()
        resolve()
      })

      iframe.appendChild(link)
      document.body.appendChild(iframe)

      $timeout(() => {
        link.click()
      }, 0, false)
    })
  }

  /**
   * @description This function will group objects by a key property
   *
   * @example
   *  array = [
   *    {
   *      id: 2,
   *      color: 'black'
   *    },
   *    {
   *      color: 'black',
   *      id: 3
   *    },
   *    {
   *      color: 'red',
   *      id: 4
   *    }
   *  ]
   *
   *  key = 'color'
   *
   *  //returns [
   *     [
   *        {
   *          id: 2,
   *          color: 'black'
   *        },
   *        {
   *          id: 3,
   *          color: 'black'
   *        }
   *     ],
   *     [
   *        {
   *          id: 4,
   *          color: 'red'
   *        }
   *     ]
   *  ]
   */
  oUtils.groupBy = function (array, key) {
    const arr = array.reduce((objectsByKeyValue, obj) => {
      const value = obj[key]
      objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj)
      return objectsByKeyValue
    }, [])

    const arrKeys = Object.keys(arr)
    arrKeys.forEach((key, index) => {
      arr[index] = arr[key]
      delete arr[key]
    })
    return arr
  }

  /**
   * @description it will join properties' values
   *
   * @example
   * arr = [
   *    [
   *      { id: 5, name: 'Bruno' },
   *      { id: 6, name: 'João' },
   *      { id: 7, name: 'Maria' },
   *    ]
   * ]
   *
   * property = 'name'
   * separator = '; '
   *
   * //returns [
   *    { id: 5, name: 'Bruno; João; Maria' }
   * ]
   */
  oUtils.joinByProperty = function (arr, property, separator) {
    const sep = separator || ', '
    return arr.map(item => {
      const values = item.map(innerItem => innerItem[property]).join(sep)
      return Object.assign({}, item[0], { [property]: values })
    })
  }

  /**
   * @description this method will reduce a number to an abbreviated format, if it's less than 1000, it just returns the value
   * @param {*} howManyUsers
   *
   * @example
   * // returns '30K'
   * Utils.formatNumbers(30000)
   *
   * @example
   * //returns '3.2K'
   * Utils.formatNumbers(3200)
   *
   * @example
   * //returns '3.25K'
   * Utils.formatNumbers(3250)
   *
   * @example
   * //returns '300'
   * Utils.formatNumbers(300)
   *
   * @returns {string} it will always return a string
   */
  oUtils.formatNumbers = function (howManyUsers) {
    var numberSufix = ['', 'K', 'M', 'G', 'T', 'P', 'E']

    const numberTier = Math.log10(howManyUsers) / 3 | 0

    if (numberTier === 0) {
      return howManyUsers.toString()
    }

    const suffix = numberSufix[numberTier]

    const baseNumber = Math.pow(10, numberTier * 3)
    const abbreviatedNumber = (howManyUsers / baseNumber).toFixed(2)

    if (abbreviatedNumber.toString().slice(-1) !== '0') {
      return abbreviatedNumber + suffix
    }

    if (abbreviatedNumber % 1 === 0) {
      return Number(abbreviatedNumber).toFixed(0) + suffix
    }

    return Number(abbreviatedNumber).toFixed(1) + suffix
  }

  oUtils.removeExtensionFromFileName = function (filename) {
    const lastDotIndex = filename.lastIndexOf('.')

    if (lastDotIndex === -1) {
      return filename
    }

    return filename.substring(0, lastDotIndex)
  }

  oUtils.getFileExtensionByName = function (fileName) {
    const regex = /(\.[^.]+)$/
    const match = fileName.match(regex)

    if (match) {
      return match[0]
    } else {
      return ''
    }
  }

  oUtils.extractTextFromHtml = function (text) {
    if (!text) {
      return ''
    }
    return text.replace(/(&.*?&gt;)/g, '').replace(/(<([^>]+)>)/ig, '')
  }

  oUtils.getImageBase64 = function (buffer) {
    return $q((resolve, reject) => {
      var reader = new FileReader()
      reader.readAsDataURL(buffer)
      reader.addEventListener('loadend', () => resolve(reader))
    })
  }

  oUtils.urltoFile = function (url, filename, mimeType) {
    return (fetch(url)
      .then(function (res) { return res.arrayBuffer() })
      .then(function (buf) { return new File([buf], filename, { type: mimeType }) })
    )
  }

  oUtils.formatDateTooltipText = function (translateKey, date, format = 'short') {
    if (!date) {
      return
    }

    return $translate.instant(translateKey, {
      date: $filter('date')(date, format)
    })
  }

  oUtils.sortByKey = function (array, key) {
    return array.sort((a, b) => a[key] > b[key] ? -1 : 1)
  }

  oUtils.getClassForProgress = function (progress) {
    if (progress >= 60) {
      return 'progress-green'
    } else if (progress > 30 && progress < 60) {
      return 'progress-yellow'
    } else {
      return 'progress-red'
    }
  }

  oUtils.addQueryStringFromArray = function (url, key, values) {
    if (!values) {
      return url
    }

    let alreadyHaveQueryParams = url.includes('?')
    let newUrl = url

    if (!alreadyHaveQueryParams) {
      newUrl = `${newUrl}?`
    }

    values.forEach(value => {
      if (alreadyHaveQueryParams) {
        newUrl = `${newUrl}&${key}=${value}`
      } else {
        newUrl = `${newUrl}${key}=${value}`
      }

      alreadyHaveQueryParams = true
    })

    return newUrl
  }

  oUtils.mapPropertyToSafeValue = function (array, property) {
    return array.map(item => {
      const obj = Object.assign({}, item)

      const newPropertyName = 'safe_' + property

      obj[newPropertyName] = $sce.trustAsHtml(item[property])

      return obj
    })
  }

  oUtils.getBusinessDaysBetweenDates = function (startMoment, endMoment) {
    if (!startMoment.isBefore(endMoment)) {
      throw new Error('End date can\'t be after start date')
    }

    let currentMoment = moment(startMoment)

    const weekends = [6, 7]
    let countDays = 0

    while (currentMoment.isBefore(endMoment)) {
      if (!weekends.includes(currentMoment.isoWeekday())) {
        countDays++
      }

      currentMoment = startMoment.add(1, 'day')
    }

    return countDays - 1
  }

  oUtils.formatsPercentage = function (value, shouldRoundValue) {
    if (shouldRoundValue) {
      return `${Math.round(value)}%`
    }

    if (value > 0 && value < 1) {
      return '< 1%'
    }

    return `${value}%`
  }

  oUtils.base64ToBlob = function (sBase64, sMime) {
    var decodeBase64 = window.atob.bind(window)

    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    var byteString = decodeBase64(sBase64)

    // write the bytes of the string to an ArrayBuffer
    var ab = new ArrayBuffer(byteString.length)
    var ia = new Uint8Array(ab)
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i)
    }

    // write the ArrayBuffer to a blob, and you're done
    return new Blob([ab], { type: sMime })
  }

  // This function below is a port from jquery.escapeSelector (3.x+)
  oUtils.jQueryEscapeSelector = function (selector) {
    function fnEscape (ch, asCodePoint) {
      if (asCodePoint) {
        // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
        if (ch === '\0') {
          return '\uFFFD'
        }

        // Control characters and (dependent upon position) numbers get escaped as code points
        return ch.slice(0, -1) + '\\' +
          ch.charCodeAt(ch.length - 1).toString(16) + ' '
      }

      // Other potentially-special ASCII characters get backslash-escaped
      return '\\' + ch
    }

    const regexEscape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g // eslint-disable-line no-control-regex
    return (selector + '').replace(regexEscape, fnEscape)
  }

  oUtils.timer = function () {
    let status = 'PAUSED'
    let seconds = 0
    let cron

    const pause = () => {
      if (status === 'PAUSED') {
        return
      }

      status = 'PAUSED'
      clearInterval(cron)
    }

    const reset = () => {
      pause()
      seconds = 0
    }

    const start = () => {
      if (status === 'COUNTING') {
        return
      }

      pause()

      status = 'COUNTING'
      cron = setInterval(() => {
        seconds++
      }, 1000)
    }

    const getSeconds = () => seconds
    const getStatus = () => status

    return {
      pause,
      reset,
      start,
      getSeconds,
      getStatus
    }
  }

  oUtils.arrayToAttributesSelector = function (arr) {
    return arr.reduce((str, item, index, array) => {
      let newVal = str

      if (!str) {
        newVal = '['
      }

      if (index === array.length - 1) {
        return `${newVal}${item}]`
      }

      return `${newVal}${item}], [`
    }, '')
  }

  oUtils.scrollRestoration = function (element = '.content-container-two-menu') {
    let scrollPosition = 0
    let keepRecording = true

    const twoMenu = document.querySelector(element)
    const startRecording = () => {
      twoMenu.addEventListener('scroll', function () {
        if (keepRecording) {
          scrollPosition = twoMenu.scrollTop
        }
      })
    }

    const restoreScroll = () => {
      twoMenu.scrollTo(0, scrollPosition)
    }

    const restartRecording = () => {
      keepRecording = true
    }

    const stopRecording = () => {
      keepRecording = false
    }

    if (twoMenu) {
      startRecording()
    }

    return { restartRecording, restoreScroll, stopRecording }
  }

  oUtils.valueIsEmpty = function (value) {
    return (
      ((value === null || value === undefined || value === '') &&
      !Array.isArray(value)) ||
      (Array.isArray(value) && !value.length))
  }

  oUtils.truncateText = function (text, limit = 25) {
    return text.length > limit ? `${text.substring(0, limit).trim()}...` : text
  }

  oUtils.formatMinutes = function (valueInMinutes) {
    const totalAbsolute = Math.abs(valueInMinutes)
    const maxMinutesInHour = 60
    const maxHoursInDay = 24
    const negativeValue = -1

    if (Math.sign(valueInMinutes) !== negativeValue) {
      const totalHours = Math.floor(valueInMinutes / maxMinutesInHour)
      const totalDays = Math.floor(totalHours / maxHoursInDay)
      const totalMinutes = valueInMinutes % maxMinutesInHour

      const hours = totalHours % maxHoursInDay

      return {
        days: totalDays,
        hours,
        minutes: Math.floor(totalMinutes)
      }
    }

    const totalMinutes = totalAbsolute % maxMinutesInHour
    const totalHours = Math.floor(totalAbsolute / maxMinutesInHour)
    const totalDays = Math.floor(totalHours / maxHoursInDay)
    const hours = totalHours % maxHoursInDay

    return {
      days: totalDays,
      hours,
      minutes: Math.floor(totalMinutes)
    }
  }

  oUtils.getSimplifyingTime = function (valueInMinutes) {
    const maxHourInDay = 24
    const oneDay = 1
    const oneHour = 1
    const sixtyMinutes = 60

    const { days, hours, minutes } = oUtils.formatMinutes(valueInMinutes)

    if (days === oneDay && hours === maxHourInDay) {
      return {
        formatted: `${days}d`
      }
    }

    if (days && hours) {
      return {
        formatted: `${days}d ${hours}h`
      }
    }

    if (hours === oneHour && minutes === sixtyMinutes) {
      return {
        formatted: `${hours}h`
      }
    }

    if (days && minutes && !hours) {
      return {
        formatted: `${days}d ${minutes}m`
      }
    }

    if (!days && hours && minutes && hours < maxHourInDay) {
      return {
        formatted: `${hours}h ${minutes}m`
      }
    }

    if (days && !hours && !minutes) {
      return {
        formatted: `${days}d`
      }
    }

    if (hours && !days && !minutes) {
      return {
        formatted: `${hours}h`
      }
    }

    if (minutes && !days && !hours) {
      return {
        formatted: `${minutes}m`
      }
    }

    return {
      formatted: '0m'
    }
  }

  oUtils.getCompleteTime = function (valueInMinutes) {
    const oneDay = 1
    const oneHour = 1
    const oneMinute = 1
    const maxHourInDay = 24
    const sixtyMinutes = 60

    const { days, hours, minutes } = oUtils.formatMinutes(valueInMinutes)

    const translatedDay = $translate.instant('timeUnit.day')
    const translatedHour = $translate.instant('timeUnit.hour')
    const translatedMinute = $translate.instant('timeUnit.minute')

    const translatedDays = days === oneDay ? translatedDay : $translate.instant('timeUnit.days')
    const translatedHours = hours === oneHour ? translatedHour : $translate.instant('timeUnit.hours')
    const translatedMinutes = minutes === oneMinute ? translatedMinute : $translate.instant('timeUnit.minutes')

    const translatedAnd = $translate.instant('timeUnit.and')

    if (days === oneDay && hours === maxHourInDay) {
      return {
        formatted: `${days} ${translatedDay}`
      }
    }

    if (days && hours) {
      return {
        formatted: `${days} ${translatedDays} ${translatedAnd} ${hours} ${translatedHours}`
      }
    }

    if (hours === oneHour && minutes === sixtyMinutes) {
      return {
        formatted: `${hours} ${translatedHour}`
      }
    }

    if (days && minutes && !hours) {
      return {
        formatted: `${days} ${translatedDays} ${translatedAnd} ${minutes} ${translatedMinutes}`
      }
    }

    if (!days && hours && minutes && hours < maxHourInDay) {
      return {
        formatted: `${hours} ${translatedHours} ${translatedAnd} ${minutes} ${translatedMinutes}`
      }
    }

    if (days && !hours && !minutes) {
      return {
        formatted: `${days} ${translatedDays}`
      }
    }

    if (hours && !days && !minutes) {
      return {
        formatted: `${hours} ${translatedHours}`
      }
    }

    if (minutes && !days && !hours) {
      return {
        formatted: `${minutes} ${translatedMinutes}`
      }
    }

    return {
      formatted: `0 ${translatedMinutes}`
    }
  }

  oUtils.convertMinutesToDays = function (valueInMinutes) {
    const maxMinutesInDay = 1440
    const expression = Math.floor(valueInMinutes / maxMinutesInDay)
    const parsedExpression = expression.toFixed(1)

    const isOneDay = expression === 1 || parsedExpression === '1.0'

    const translatedDay = $translate.instant('timeUnit.day')
    const translatedDays = isOneDay ? translatedDay : $translate.instant('timeUnit.days')

    if (Number.isInteger(expression)) {
      return `${expression} ${translatedDays}`
    }

    return `${parsedExpression} ${translatedDays}`
  }

  oUtils.convertSecondsToMinutes = function (seconds) {
    if (isNaN(seconds)) {
      throw new Error('seconds must be a number')
    }

    const minutes = seconds / 60

    return Math.ceil(minutes)
  }

  oUtils.debounce = function (func, timeout = 300) {
    let timer = null

    return (...args) => {
      clearTimeout(timer)
      timer = setTimeout(() => func.apply(this, args), timeout)
    }
  }

  oUtils.capitalize = function (string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }

  oUtils.daysUntilDelivery = function (deliveryDate) {
    const currentDate = new Date()
    const deliveryDateTime = new Date(deliveryDate)
    deliveryDateTime.setHours(0)
    deliveryDateTime.setMinutes(0)
    deliveryDateTime.setSeconds(0)

    const timeDifference = deliveryDateTime - currentDate
    const daysDifference = timeDifference / (1000 * 60 * 60 * 24)

    return Math.ceil(daysDifference)
  }

  /**
   * @description this method will return a formatted date using Intl API
   *
   * @param {String | Date} date
   * @param {String} locale
   * @param {Intl.DateTimeFormatOptions | undefined} options
   *
   * @returns {String}
   *
   * **e.g.: '10/20/2023'**
   *
   * *it will always return a string*
   */
  oUtils.formatDate = function (date, locale, options = {}) {
    const defaultOptions = {
      timeZone: 'America/Sao_Paulo'
    }
    const formattedDate = new Intl.DateTimeFormat(locale, { ...options, ...defaultOptions }).format(new Date(date))

    return formattedDate
  }

  /**
   * @description this method will return a formatted number using Intl API
   *
   * @param {Number | BigInt} number
   * @param {String} locale
   * @param {Intl.NumberFormatOptions | undefined} options
   *
   * @returns {String}
   *
   * **e.g.: '4,8'**
   *
   * *it will always return a string*
   */
  oUtils.formatNumber = function (number, locale, options) {
    const formattedNumber = new Intl.NumberFormat(locale, options).format(number)

    return formattedNumber
  }

  oUtils.getImageRealMimeType = function (file) {
    const fileReader = new FileReader()

    return new Promise((resolve) => {
      fileReader.onloadend = function (event) {
        let mimeType = ''

        const arr = new Uint8Array(event.target.result).subarray(
          0,
          4
        )
        let header = ''

        for (let index = 0; index < arr.length; index++) {
          header += arr[index].toString(16)
        }

        switch (header) {
          case '89504e47': {
            mimeType = 'image/png'
            break
          }
          case '47494638': {
            mimeType = 'image/gif'
            break
          }
          case '52494646':
          case '57454250':
            mimeType = 'image/webp'
            break
          case '49492A00':
          case '4D4D002A':
            mimeType = 'image/tiff'
            break
          case 'ffd8ffe0':
          case 'ffd8ffe1':
          case 'ffd8ffe2':
          case 'ffd8ffe3':
          case 'ffd8ffe8':
            mimeType = 'image/jpeg'
            break
          default:
            mimeType = file.type
            break
        }

        resolve(mimeType)
      }

      fileReader.readAsArrayBuffer(file)
    })
  }

  oUtils.getUsageUrlForModule = function (params = {}) {
    const { assetId: previewId, linkedResourceId, locationId, location } = params

    switch (location) {
      case 'repository':
        return $state.href('repository.all', { previewId })
      case 'posts':
        return $state.href('posts', { post: linkedResourceId })
      case 'arts':
        return $state.href('arts.collection', { id: locationId, previewId: linkedResourceId })
      case 'tasks':
        return $state.href('workflow.kanban', { board: locationId, request: linkedResourceId })
      case 'checklist':
        return $state.href('auditForm', { id: linkedResourceId })
      case 'brand':
        return $state.href('brand', { previewId })
      case 'publiclink': {
        const absUrl = $location.absUrl()
        const baseUrl = new $window.URL(absUrl)

        return `${baseUrl.origin}/${$state.href('publicDownload', { uuid: locationId })}`
      }
      case 'templates': {
        return $state.href('customizeArt', {
          idArt: linkedResourceId
        })
      }
      default:
        return $state.href($state.current.name, { previewId })
    }
  }

  oUtils.getFileTypeForMpegFiles = function (file) {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)()

    if (!audioContext) {
      return Promise.resolve(file.type)
    }

    return new Promise((resolve) => {
      file.arrayBuffer().then((arrayBuffer) => {
        audioContext.decodeAudioData(
          arrayBuffer,
          () => {
            resolve('audio/mpeg')
          },
          () => {
            resolve('video/mpeg')
          }
        )
      })
    })
  }

  oUtils.defineOptimalChunkSize = (fileSize) => {
    switch (true) {
      case fileSize < 50000000: // 50mb
        return 5 * 1024 * 1024
      case fileSize < 200000000: // 200mb
        return 20 * 1024 * 1024
      default: // > 200mb
        return 50 * 1024 * 1024
    }
  }

  oUtils.convertToArray = (value) => {
    if (!value) {
      return value
    }

    return Array.isArray(value) ? value : [value]
  }

  oUtils.createScoreArray = (length) => {
    const scoreArray = []

    for (let score = 1; score <= length; score++) {
      scoreArray[score] = {
        label: `${score} ${$translate.instant(score === 1 ? 'star' : 'stars')}`,
        value: score,
        id: score,
        icon: 'star'
      }
    }

    return scoreArray
  }

  oUtils.searchByArray = (items, query) => {
    return items.filter((item) => {
      if (item.label) {
        return item.label.toLowerCase().includes(query.toLowerCase())
      }

      if (item.name) {
        return item.name.toLowerCase().includes(query.toLowerCase())
      }

      if (item.title) {
        return item.title.toLowerCase().includes(query.toLowerCase())
      }

      return item.toLowerCase().includes(query.toLowerCase())
    })
  }

  oUtils.fileIsFolder = (file) => {
    return new Promise(function (resolve, reject) {
      if (file.type !== '') {
        return resolve(file)
      }

      const reader = new FileReader()
      reader.onloadend = () => {
        if (reader.error && (reader.error.name === 'NotFoundError' || reader.error.name === 'NotReadableError')) {
          return reject(reader.error.name)
        }

        resolve(file)
      }

      reader.readAsArrayBuffer(file)
    })
  }

  oUtils.isMpegFile = (fileExtension) => {
    return fileExtension === 'mpg' || fileExtension === 'mpeg'
  }

  oUtils.convertPixelsToCm = (pixels) => {
    const dpi = 72
    const cmFactor = 2.54
    const cm = cmFactor * pixels / dpi
    return cm.toFixed(2)
  }

  oUtils.removeNBSPSymbol = (value) => {
    const nonBreakingSpaceSymbol = '&nbsp;'
    const emptySpace = ' '

    return value.replaceAll(nonBreakingSpaceSymbol, emptySpace)
  }

  oUtils.isValidHashtag = (string) => {
    const regex = new RegExp(/^#[^~`!@#$%^&*+=[\]{};:"'<>,.?/|\\\s-]+$/)
    return regex.test(string)
  }

  oUtils.splice = (string, idx, rem, newValue) => {
    return string.slice(0, idx) + newValue + string.slice(idx + Math.abs(rem))
  }

  oUtils.getTimeSince = (date, locale) => {
    const MILLISECONDS_IN_SECOND = 1000
    const SECONDS_IN_MINUTE = 60
    const MINUTES_IN_HOUR = 60
    const HOURS_IN_DAY = 24
    const DAYS_IN_MONTH = 30
    const DAYS_IN_YEAR = 365

    const MILLISECONDS_IN_MINUTE = MILLISECONDS_IN_SECOND * SECONDS_IN_MINUTE
    const MILLISECONDS_IN_HOUR = MILLISECONDS_IN_MINUTE * MINUTES_IN_HOUR
    const MILLISECONDS_IN_DAY = MILLISECONDS_IN_HOUR * HOURS_IN_DAY
    const MILLISECONDS_IN_MONTH = MILLISECONDS_IN_DAY * DAYS_IN_MONTH
    const MILLISECONDS_IN_YEAR = MILLISECONDS_IN_DAY * DAYS_IN_YEAR

    const now = new Date()
    const past = new Date(date)
    const diffInMs = now - past

    const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' })

    if (diffInMs < MILLISECONDS_IN_MINUTE) {
      const seconds = Math.floor(diffInMs / MILLISECONDS_IN_SECOND)
      return seconds <= 5 ? $translate.instant('justNow') : rtf.format(-seconds, 'second')
    }

    if (diffInMs < MILLISECONDS_IN_HOUR) {
      const minutes = Math.floor(diffInMs / MILLISECONDS_IN_MINUTE)
      return rtf.format(-minutes, 'minute')
    }

    if (diffInMs < MILLISECONDS_IN_DAY) {
      const hours = Math.floor(diffInMs / MILLISECONDS_IN_HOUR)
      return rtf.format(-hours, 'hour')
    }

    if (diffInMs < MILLISECONDS_IN_MONTH) {
      const days = Math.floor(diffInMs / MILLISECONDS_IN_DAY)
      return rtf.format(-days, 'day')
    }

    if (diffInMs < MILLISECONDS_IN_YEAR) {
      const months = Math.floor(diffInMs / MILLISECONDS_IN_MONTH)
      return rtf.format(-months, 'month')
    }

    const years = Math.floor(diffInMs / MILLISECONDS_IN_YEAR)

    return rtf.format(-years, 'year')
  }

  oUtils.processTextsWithLinks = (strings) => {
    return strings.map((string) => {
      if (string === null || string === undefined) return ''

      const regex = /(https?:\/\/[^\s]+)/g
      const labelHtml = string.replace(regex, (match) => {
        return `<a href="${match}" target="_blank">${match}</a>`
      })

      return $sce.trustAsHtml(labelHtml)
    })
  }

  oUtils.isNanoId = (id) => {
    const regExp = /[a-z]/i
    return regExp.test(id.toString())
  }

  oUtils.toValidUrl = function (str) {
    if (!str) return ''
    let url = str.trim()
    if (!/^https?:\/\//i.test(url)) {
      url = 'https://' + url
    }
    try {
      return new URL(url).toString()
    } catch (e) {
      return ''
    }
  }

  /**
   * @param {Array} array
   * @param {function} filter - a callback that receives the item of the array and returns a boolean
   * @returns {Array} an array containing two arrays:
   *   the first one that passes the condition and the other array is the remaining items
   */
  oUtils.partition = (array, filter) => {
    return array.reduce(
      ([pass, fail], item) => {
        return filter(item) ? [[...pass, item], fail] : [pass, [...fail, item]]
      },
      [[], []]
    )
  }

  /**
   * @param {string} hex
   * @param {number} opacity
   * @returns {string} a rgba string
   */
  oUtils.hexToRgba = function (hex, opacity) {
    hex = hex.replace('#', '')
    const bigint = parseInt(hex, 16)
    const r = (bigint >> 16) & 255
    const g = (bigint >> 8) & 255
    const b = bigint & 255
    return `rgba(${r}, ${g}, ${b}, ${opacity})`
  }

  /**
   * @param {string} text
   * @returns {string} a html string with the text split into lines
   */

  oUtils.lineBreakTooltipText = function (text) {
    if (!text) return ''
    const maxLength = 40
    const lines = []
    let currentLine = ''

    for (let i = 0; i < text.length; i++) {
      const char = text[i]

      if (currentLine.length >= maxLength) {
        lines.push(currentLine.trim())
        currentLine = char
      } else {
        currentLine += char
      }
    }

    if (currentLine.trim()) {
      lines.push(currentLine.trim())
    }

    return lines.map(line => `<p>${line}</p>`).join('')
  }

  return oUtils
}

export { utils }
